export enum EstatusReclutamiento {
    BUSQUEDA="BÚSQUEDA",
    ENTREVISTAS="ENTREVISTAS",
    EVALUACION= "EVALUACIÓN",
    SELECCION="SELECCIÓN"
}